import * as React from 'react'
import * as ReactDOM from 'react-dom'
import '../styles/App.scss'
import '../styles/App-media.scss'
import '../styles/Signin.scss'
import { FlatButton } from 'material-ui'
import { Link } from 'react-router-dom'
import { AppBarContainer } from './CustomAppBar'
import { LoadingSpinner } from '../components/LoadingSpinner'
import { RouterState, RouterAction, routerActions } from 'react-router-redux'
import { connect, Dispatch } from 'react-redux'

import * as Auth from '../services/auth/auth'
import { Api } from '../services/api/api'

import { ClientInfo, Preference, TermsArray } from '../types'
import { DEFAULT_ROUTE, ROUTES } from '../constants/routes'

import { ActionType, Actions } from '../actions/signIn'
import { StoreState } from '../reducers'
import { isNullOrUndefined } from 'util'
import PageTitle from '../components/PageTitle'
import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'
import { StickyContainer, Sticky } from 'react-sticky'

import { Error as ErrorInfo } from '../types/Errors/Error'
import { ActionType as ErrorInfoActionType, Actions as ErrorActions } from '../actions/errorInfo'
import Mapper from '../utils/Mapper'
import {ClientType} from '../types/enums';
import {PreferenceType} from '../types/enums/PreferenceType';

interface SignInProps {
  isSigned: boolean
  isSigningInProcess: boolean
  onSignStarted: () => ActionType
  onUserSigned: (userData: ClientInfo) => ActionType
  onUserSignError: (error: string) => ActionType
  onSetTutorialLink: (link: Preference) => ActionType
  onLogOut: () => ActionType
  routePush: (location: string) => RouterAction
  onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
}

interface SignInState {
  login: string
  password: string
  signInError: string
  emailError: string
  isPatternValid: boolean
  isValid: boolean
}

export class SignIn extends React.Component<SignInProps, SignInState> {
  constructor(props: any) {
    super(props)
    this.state = {
      login: '',
      password: '',
      signInError: '',
      emailError: '',
      isPatternValid: false,
      isValid: false
    }
  }

  handleEmailChange = (event: any) => {
    if (RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/).test(event.target.value)) {
      this.setState({
        isPatternValid: true,
        emailError: ''
      })
    } else if (event.target.value === '') {
      this.setState({
        emailError: ''
      })
    } else {
      this.setState({
        emailError: StringResources.getString(Strings.SignIn.Errors.Email)
      })
    }
    this.setState({
      login: event.target.value
    })
    this.setIsValid()
  }

  handlePasswordChange = (event: any) => {
    this.setState({
      password: event.target.value
    })
    this.setIsValid()
  }

  componentDidMount() {
    if (this.props.isSigned) {
      // redirect to pickup location
      this.props.routePush(DEFAULT_ROUTE)
    }
  }

  onSignIn = () => {
    let login = this.state.login.toLowerCase()
    Auth.signIn({ login: login, password: this.state.password })
      .then(res => {
        this.getAndSaveUserData()
      })
      .catch(error => {
        this.props.onUserSignError(error)
        console.log(error.message)
        this.setState({
          signInError: error.message
        })
      })
    this.props.onSignStarted()
  }

  getAndSaveUserData = () => {
    Api.getClientInfo()
      .then((userData: ClientInfo) => {
        Api.getTerms()
          .then((result: TermsArray[]) => {
            let index = result.findIndex(term => term.isAccepted === false)
            userData.isTermsAccepted && index === -1 ? this.props.routePush(DEFAULT_ROUTE) : this.props.routePush(ROUTES.TERMS)
          })
          .catch((error) => {
            this.props.onErrorEvent(Mapper.mapError(error))
          })
        this.props.onUserSigned(userData)
      })
      .catch(error => {
        this.props.onUserSignError(error)
      })
    Api.getPreference(PreferenceType.TutorialLink)
        .then(link => {
        this.props.onSetTutorialLink(link)
      }).catch(error => {
        console.log('Error tutorial link: ', error)
      })
  }

  onKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
      e.target.blur()
      if (this.state.isValid) {
        this.onSignIn()
      }
    }
  }

  setIsValid = () => {
    this.setState(prevState => {
      let isValid = (this.state.password !== '') && this.state.isPatternValid
      return { ...prevState, isValid }
    })
  }

  render() {
    return (
      <BaseContainer pageName={EventType.SIGN_IN}>
        <LoadingSpinner show={this.props.isSigningInProcess} />
        <AppBarContainer
          isIconButtonsShown={false}
          isMenuShown={false}
        />
        <PageTitle text={StringResources.getString(Strings.SignIn.Title)} />
        <div className="vertical-scrollbar" >
          <form className="signin-form">
            <p>{StringResources.getString(Strings.SignIn.Labels.Login)}</p>
            <input
              type="email"
              // placeholder="Username"
              value={this.state.login}
              onChange={this.handleEmailChange}
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
              onKeyDown={this.onKeyDown}
              // required={true}
              style={this.state.login === '' || (this.state.login !== '' && this.state.isPatternValid) ? undefined : { borderColor: 'red' }}
            />
            <p className="error-text">{this.state.emailError}</p>
            <p>{StringResources.getString(Strings.SignIn.Labels.Password)}</p>
            <input
              type="password"
              // placeholder="Enter Your Password"
              value={this.state.password}
              onChange={this.handlePasswordChange}
              onKeyDown={this.onKeyDown}
            // required={true}
            />
            <p className="error-text">{this.state.signInError}</p>
            <div className="sign-in-links">
              <li id="first-link"><Link to={ROUTES.FORGOT_PASSWORD}>{StringResources.getString(Strings.SignIn.Links.ForgotPassword)}</Link></li>
              <li className="align-right"><Link to={ROUTES.NEW_ACCOUNT}>{StringResources.getString(Strings.SignIn.Links.CreateNewAccount)}</Link></li>
            </div>
          </form>
        </div>
        <StickyContainer className="sticky-footer sb" >
          <Sticky>
            {() => (
              <div className={'bottom-part hover'}>
                <FlatButton
                  label={StringResources.getString(Strings.SignIn.Buttons.SignIn.label)}
                  className={!this.state.login || !this.state.password || !this.state.isPatternValid ? 'flatbutton disabled' : 'flatbutton'}
                  disabled={!this.state.login || !this.state.password || !this.state.isPatternValid}
                  onClick={this.onSignIn}
                />
              </div>
            )}
          </Sticky>
        </StickyContainer>
      </BaseContainer>
    )
  }
}

function mapStateToProps(state: StoreState) {
  return {
    routing: state.routing,
    isSigned: state.auth.isSigned,
    isSigningInProcess: state.auth.isSigningInProcess
  }
}

function mapDispatchToProps(dispatch: Dispatch<RouterAction | ActionType>) {
  return {
    routePush: (location: string) => dispatch(routerActions.push(location)),
    onSignStarted: () => dispatch(Actions.signing()),
    onUserSigned: (userData: ClientInfo) => dispatch(Actions.authorize(userData)),
    onUserSignError: (error: string) => dispatch(Actions.unathorize(error)),
    onSetTutorialLink: (link: Preference) => dispatch(Actions.setTutorialLink(link)),
    onLogOut: () => dispatch(Actions.logOut()),
    onErrorEvent: (errorInfo: ErrorInfo) => dispatch(ErrorActions.newError(errorInfo))
  }
}

export const SignInContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignIn)



// WEBPACK FOOTER //
// ./src/containers/SignIn.tsx